import React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import { render, MARK_LINK } from 'storyblok-rich-text-react-renderer';
import { LinkWrapper } from '../../../utils/link';
import Text from '../text';
import ButtonLink from '../../buttons/button_link';
import ContentBlock from '../content_block/ContentBlock';

const QuizResult = ({ blok }) => {
  const RichText = ({ document }) => {
    return render(document, {
      defaultBlokResolver: (name, props) => {
        const blok = { ...props, component: name };
        return <StoryblokComponent blok={blok} key={blok._uid} />;
      },
      markResolvers: {
        [MARK_LINK]: (children, props) => {
          return <LinkWrapper link={props}>{children}</LinkWrapper>;
        },
      },
    });
  };

  /*  return (
    <div
      className="w-full col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3 grid grid-cols-12 relative mt-8 bg-yellow-15"
      {...storyblokEditable(blok)}
    >
      <div className="col-span-12 relative aspect-4/3">
        {blok.image?.map((img) => (
          <StoryblokComponent blok={img} />
        ))}
        <div className="absolute bottom-0 m-2 p-2 bg-white rounded">
          <span className="font-crystalCondensed">{blok.title}</span>
        </div>
      </div>
      <div className="col-span-12">
        <Text blok={blok} />
      </div>
      <div className="col-span-12">
        {blok.link?.map((link) => (
          <ButtonLink blok={link} />
        ))}
      </div>
    </div>
  );*/

  const img =
    blok.image?.length > 0 ? <StoryblokComponent blok={blok.image[0]} /> : null;

  const links = blok.link?.map((link) => <ButtonLink blok={link} />);

  return (
    <ContentBlock
      image={img}
      text={RichText({ document: blok.text })}
      cta={links}
    />
  );
};

export default QuizResult;
